/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as types from "../../types/primitives.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import { Auth0Config, Auth0Config$inboundSchema } from "./auth0config.js";
import { BuildConfig, BuildConfig$inboundSchema } from "./buildconfig.js";
import {
  DeploymentConfig,
  DeploymentConfig$inboundSchema,
} from "./deploymentconfig.js";
import {
  LaunchDarklyConfig,
  LaunchDarklyConfig$inboundSchema,
} from "./launchdarklyconfig.js";
import {
  PreauthenticationConfig,
  PreauthenticationConfig$inboundSchema,
} from "./preauthenticationconfig.js";

export type ApplicationConfig = {
  /**
   * Information for connecting to our authentication provider
   */
  auth0?: Auth0Config | undefined;
  /**
   * Information about the software version that is deployed
   */
  build: BuildConfig;
  /**
   * Information about the environment that the software is deployed to
   */
  deployment: DeploymentConfig;
  /**
   * Information about our feature flag provider
   */
  launchDarkly: LaunchDarklyConfig;
  /**
   * Indication that the Gaia session is pre-authenticated via AgentProxy Mode (aka Local Online Mode).
   */
  preauthentication?: PreauthenticationConfig | undefined;
};

/** @internal */
export const ApplicationConfig$inboundSchema: z.ZodType<
  ApplicationConfig,
  z.ZodTypeDef,
  unknown
> = z.object({
  auth0: types.optional(Auth0Config$inboundSchema),
  build: BuildConfig$inboundSchema,
  deployment: DeploymentConfig$inboundSchema,
  launch_darkly: LaunchDarklyConfig$inboundSchema,
  preauthentication: types.optional(PreauthenticationConfig$inboundSchema),
}).transform((v) => {
  return remap$(v, {
    "launch_darkly": "launchDarkly",
  });
});

export function applicationConfigFromJSON(
  jsonString: string,
): SafeParseResult<ApplicationConfig, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ApplicationConfig$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ApplicationConfig' from JSON`,
  );
}
